import { toast } from 'sonner';
import { useAppStore } from '@/hooks/use-app-store'; // It's okay for a service to import the store

const IDLE_WARNING_COUNTDOWN_S = 15;
let countdownTimer: NodeJS.Timeout | null = null;
let lastActivity:number = 0;

export const IdleCountdownManager = {
  start: () => {
    // Prevent multiple countdowns from starting
    if (window.countdownTimer) return;

    let secondsLeft = IDLE_WARNING_COUNTDOWN_S;

    const updateToast = () => {
      toast.info(`Connection idle. Reconnecting in ${secondsLeft}s...`, {
        id: 'idle-warning-toast',
        duration: Infinity,
      });
    };

    updateToast(); // Show the initial toast

    window.countdownTimer = setInterval(() => {
      secondsLeft--;
      if (secondsLeft <= 0) {
        IdleCountdownManager.cancel(); // Clean up this timer
        useAppStore.getState().resetExperience(); // Reset experience instead of reconnect
      } else {
        updateToast(); // Update the message
      }
    }, 1000);
  },

  cancel: () => {
    lastActivity = Date.now();
    if (window.countdownTimer) {
      clearInterval(window.countdownTimer);
      window.countdownTimer = null;
      toast.dismiss('idle-warning-toast');
      console.log('Idle reconnect cancelled by user activity.');
    }
  },

  updateActivity: () => {
    lastActivity = Date.now();
  },
  
  getLastActivity: () => {
    return lastActivity;
  }
};